import React, { useState, useEffect } from "react";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as MagnifiyingGlass } from "../../assets/navbar/MagnifyingGlass.svg";
import { Link } from "react-router-dom";
import NavbarLeft from "../Components/NavbarLeft";
import ReportTable from "./components/ReportTable";

// import HistoryTopBar from "./components/HistoryTopBar";
// import HistoryTable from "./components/HistoryTable";
import ComponentLoading from "../../commonComponents/ComponentLoading";

// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchAnalysisHistory, setAnalysisHistory } from "../../redux/actions/analysisActions";
import { fetchOptimizationHistory, setOptimizationHistory } from "../../redux/actions/optimizationActions";
import { setComHistory } from "../../redux/actions/comActions";
import AnalysisStep from "../Components/AnalysisStep";
import ReportChoiceTopBar from "./components/ReportChoiceTopBar";
import { useLocation } from "react-router-dom";

const ReportChoice = () => {
  const location = useLocation();

  ///////////////////////// ANALYSIS DATA /////////////////////////
  // REDUX ACTIONS
  const dispatch = useDispatch();
  const fetchAnalysisHistory_rd = () => dispatch(fetchAnalysisHistory());
  // REDUX STATES
  const analysis_history = useSelector((state) => (state.analysis.analysis_history ? state.analysis.analysis_history : null));
  const analysis_history_filtred = useSelector((state) =>
    state.analysis.analysis_history_filtred ? state.analysis.analysis_history_filtred : state.analysis.analysis_history ? state.analysis.analysis_history : null
  );

  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)
  // const setAnalysisHistory_rd = (data) => dispatch(setAnalysisHistory(data));
  const [rand_update, set_rand_update] = useState(null);

  useEffect(() => {
    async function fetch_fn() {
      setLoading(true);
      await fetchAnalysisHistory_rd();
    }
    // if (!optimization_history) {
    fetch_fn();
    // setAnalysisHistory_rd(analysis_history);
    // }
  }, [analysis_data]);

  // const [analysis_history_filterer, set_analysis_history_filterer] = useState(null);
  const [loading, setLoading] = useState(false);
  ///////////////////////// OPTIMIZATION DATA /////////////////////////
  // REDUX ACTIONS
  const fetchOptimizationHistory_rd = () => dispatch(fetchOptimizationHistory());
  // REDUX STATES
  const optimization_history = useSelector((state) => (state.optimization.optimization_history ? state.optimization.optimization_history : null));
  const optimization_history_filtred = useSelector((state) =>
    state.optimization.optimization_history_filtred ? state.optimization.optimization_history_filtred : state.optimization.optimization_history ? state.optimization.optimization_history : null
  );

  const optimization_data = useSelector((state) => state.optimization.optimization_data, shallowEqual); //? state.analysis.optimization_data : null)
  const setOptimizationHistory_rd = (data) => dispatch(setOptimizationHistory(data));

  useEffect(() => {
    async function fetch_fn() {
      await fetchOptimizationHistory_rd();
      setLoading(false);
    }
    // if (!optimization_history) {
    fetch_fn();
    // setOptimizationHistory_rd(optimization_history);
    // }
  }, [optimization_data]);

  const [optimization_history_filterer, set_optimization_history_filterer] = useState(null);

  ///////////////////////// CONCAT DATA /////////////////////////
  // const [all_history, set_all_history] = useState([]);
  const [all_history_filterer, set_all_history_filterer] = useState([]);
  const setComHistory_rd = (data) => dispatch(setComHistory(data));
  const all_history = useSelector((state) => (state.com.all_history ? state.com.all_history : null));
  const all_history_filtred = useSelector((state) => (state.com.all_history_filtred ? state.com.all_history_filtred : state.com.all_history ? state.com.all_history : null));
  const redux_state = useSelector((state) => state);

  const concatenate_history = () => {
    const opt = {};
    // if (location.state && location.state.sub_type !== "kit eco-score") {
    //   console.log('optimization_history ONGOING')
    //   Object.entries(optimization_history).map((x) => {
    //     opt["opt_" + x[0]] = {
    //       type: "optimisation",
    //       active_users: x[1].active_users,
    //       createdAt: x[1].createdAt,
    //       eco_score: x[1].eco_score,
    //       product_name: x[1].product_name,
    //       ref: x[1].ref,
    //       status: x[1].status,
    //     };
    //   });
    // }

    const anl = {};
    Object.entries(analysis_history).map((x) => {
      anl["anl_" + x[0]] = {
        type: "analyse",
        active_users: x[1].active_users,
        createdAt: x[1].createdAt,
        eco_score: x[1].eco_score,
        product_name: x[1].product_name,
        ref: x[1].ref,
        status: x[1].status,
      };
    });
    console.log("HERE", anl);
    return Object.assign({}, opt, anl);
  };
  useEffect(() => {
    if (analysis_history) {
      // set_all_history(concatenate_history());
      console.log("meeetoo", concatenate_history());
      setComHistory_rd(concatenate_history());
      setLoading(false);
    }
  }, [optimization_history_filtred, analysis_history_filtred]);

  return (
    <>
      <NavbarLeft currentPage={4} />

      <ReportChoiceTopBar sub_type={location.state && location.state.sub_type} all_history={all_history} set_all_history_filterer={set_all_history_filterer} set_rand_update={set_rand_update} />

      {!loading && all_history_filtred ? (
        <ReportTable
          navigate_to={location.state && location.state.number === 8 ? "EcoKit" : "Report"} // TODO
          all_history={all_history_filtred}
          all_history_filterer={all_history_filterer}
          rand_update={rand_update}
          set_rand_update={set_rand_update}
        />
      ) : (
        <>
          {/* <p
            onClick={() => {
              console.log("analysis_history", redux_state.com, all_history, loading);
              // let opt = {}
              // Object.entries(analysis_history).map((x) => {
              //   console.log('xx', x)
              //   opt["anl_" + x[0]] = {
              //     type: "analyse",
              //     active_users: x[1].active_users,
              //     createdAt: x[1].createdAt,
              //     eco_score: x[1].eco_score,
              //     product_name: x[1].product_name,
              //     ref: x[1].ref,
              //     status: x[1].status,
              //   };
              // })
              // console.log(
              //   "all_history_filtred",
              //   opt
              // );
            }}
          >
            DEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUG
          </p> */}
          <ComponentLoading height={35} style={"h-[400px] flex items-center justify-center"} />
        </>
      )}
    </>
  );
};

export default ReportChoice;
